import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';

function ButtonPagamento({ chave, renderButtons }) {
  const [showPreview, setShowPreview] = useState(false);

  function copyToClipboard(text) {
    const normalizedText = String(text || '').trim();
    if (!normalizedText) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(normalizedText)
        .then(() => toast.success('copiado'))
        .catch(() => {
          const ta = document.createElement('textarea');
          ta.value = normalizedText;
          document.body.appendChild(ta);
          ta.select();
          try {
            document.execCommand('copy');
            toast.success('copiado');
          } finally {
            document.body.removeChild(ta);
          }
        });
      return;
    }

    const ta = document.createElement('textarea');
    ta.value = normalizedText;
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
      toast.success('copiado');
    } finally {
      document.body.removeChild(ta);
    }
  }

  function handleButtonClick(e, value) {
    e.stopPropagation();
    if (showPreview) {
      copyToClipboard(value);
      setShowPreview(false);
    } else {
      setShowPreview(true);
    }
  }

  function handleClosePreview(e) {
    e.stopPropagation();
    setShowPreview(false);
  }

  const paymentAction = (() => {
    if (chave.tipocod === 'P' && chave.pix_qr_code) {
      return {
        label: 'Ver Pix',
        variant: 'outline-success',
        ariaLabel: 'Copiar código Pix',
        value: chave.pix_qr_code,
        previewLabel: 'Código PIX',
      };
    }

    if (chave.tipocod === 'B' && chave.barras) {
      return {
        label: 'Ver Cod. Leitor',
        variant: 'outline-secondary',
        ariaLabel: 'Copiar código leitor',
        value: chave.barras,
        previewLabel: 'Código Leitor',
      };
    }

    if (chave.tipocod === 'D' && chave.barras) {
      return {
        label: 'Ver Lin. Digitável',
        variant: 'outline-warning',
        ariaLabel: 'Copiar linha digitável',
        value: chave.barras,
        previewLabel: 'Linha Digitável',
      };
    }

    return null;
  })();
  if (!paymentAction) {
    return renderButtons(null);
  }

  const previewBox = showPreview ? (
    <div
      className="d-md-none"
      style={{
        backgroundColor: '#f8f9fa',
        border: '1px solid #dee2e6',
        borderRadius: '4px',
        padding: '8px 10px',
        marginBottom: '8px',
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="d-flex justify-content-between align-items-start mb-1">
        <small className="text-muted font-weight-bold">
          {paymentAction.previewLabel}:
        </small>
        <button
          type="button"
          className="close"
          aria-label="Fechar"
          onClick={handleClosePreview}
          style={{
            padding: '0 4px',
            fontSize: '1.2rem',
            lineHeight: '1',
            marginTop: '-2px',
          }}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div
        style={{
          wordBreak: 'break-all',
          overflowWrap: 'break-word',
          fontSize: '0.85rem',
          lineHeight: '1.3',
          maxWidth: '100%',
          fontFamily: 'monospace',
          backgroundColor: '#fff',
          padding: '6px 8px',
          borderRadius: '3px',
          border: '1px solid #e9ecef',
        }}
      >
        {String(paymentAction.value || '').trim()}
      </div>
    </div>
  ) : null;

  const paymentButton = (
    <Button
      type="button"
      size="sm"
      variant={paymentAction.variant}
      className="d-md-none mr-2"
      style={{ minWidth: '120px' }}
      aria-label={paymentAction.ariaLabel}
      disabled={!String(paymentAction.value || '').trim()}
      onClick={(e) => handleButtonClick(e, paymentAction.value)}
    >
      {showPreview ? 'Copiar' : paymentAction.label}
    </Button>
  );

  return (
    <>
      {previewBox}
      {renderButtons(paymentButton)}
    </>
  );
}

export default ButtonPagamento;
